// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-components-EntityUser-Avatar-_VUM7S","dot":"styles-module__dot__src-labstep-web-components-EntityUser-Avatar-_VK8OL"};